import { createSelector } from 'reselect';

const adSlotSelector = state => state.slot;

const firmSelector = state => state.firm;
const listingSelector = state => state.listing;
const userSelector = state => state.user;
const adminSelector = state => state.admin;
const routerSelector = state => state.router;
const campaignSelector = state => state.campaign;
const invoiceSelector = state => state.invoice;

// AD SLOTS
export const getAdSlots = createSelector(adSlotSelector, state => state.slots);
export const getCurrentAdSlot = createSelector(adSlotSelector, state => state.current);
export const getItemsForFirms = createSelector(adSlotSelector, state => state.items);

// FIRMS
export const getFirms = createSelector(firmSelector, state => state.firms);
export const getRepOptionsForFirm = createSelector(firmSelector, state => state.repOptions);
export const getCurrentFirm = createSelector(firmSelector, state => state.current);

// LISTINGS
export const getListings = createSelector(listingSelector, state => state.listings);
export const getCurrentListing = createSelector(listingSelector, state => state.current);
export const getTypeOptions = createSelector(listingSelector, state => state.typeOptions);

// ROUTES
export const getRoutes = createSelector(userSelector, state => state.routes);

// CURRENT USER
export const getLoginStatus = createSelector(userSelector, state => state.loggedIn);
export const getUser = createSelector(userSelector, state => state.user);

// USERS
export const getUsers = createSelector(adminSelector, state => state.users);
export const getUserOptions = createSelector(adminSelector, state => state.userOptions);
export const getEditors = createSelector(adminSelector, state =>
  state.users
    .filter(u => u.roles.find(({ name }) => name === 'editor'))
    .map(({ id, name }) => ({ key: id, text: name, value: id }))
);
export const getCurrentAdminUser = createSelector(adminSelector, state => state.currentUser);
export const getCurrentAdminGroup = createSelector(adminSelector, state => state.currentGroup);
export const getCurrentAdminGroupId = createSelector(adminSelector, state => state.currentGroupId);

// PROPERTIES
export const getProperties = createSelector(adminSelector, state => state.properties);

// ROLES
export const getAdminRoles = createSelector(adminSelector, state => state.roles);

// GROUPS
export const getAdminGroups = createSelector(adminSelector, state => state.groups);
export const getCurrentGroup = createSelector(adminSelector, state => state.currentGroup);

// SITES
export const getSites = createSelector(adminSelector, state => state.sites);
export const getSiteOptions = createSelector(adminSelector, state => state.sitesOptions);
export const getSiteOptionsDetail = createSelector(adminSelector, state => state.sitesOptionsDetail);

const isMapSite = s => !s.text.toLowerCase().includes('map');
export const getCultureMapSites = createSelector(adminSelector, state => state.sitesOptionsDetail?.filter(isMapSite));
export const getDallasId = createSelector(
  adminSelector,
  state => state.sitesOptionsDetail?.find(s => s.text.toLowerCase().includes('dallas')).key
);
export const getCityOptions = createSelector(adminSelector, state => state.citiesOptions);
export const getCurrentSite = createSelector(adminSelector, state => state.currentSite);

// SITES
export const getCurrentPath = createSelector(routerSelector, state => state.location.pathname);

// CAMPAIGN
export const getCurrentDigest = createSelector(campaignSelector, state => state.digest);
export const getDigests = createSelector(campaignSelector, state => state.digests);
export const getCurrentHotw = createSelector(campaignSelector, state => state.hotw);
export const getHomesOfTheWeek = createSelector(campaignSelector, state => state.hotws);
export const getCurrentPromoAlert = createSelector(campaignSelector, state => state.promoAlert);
export const getPromoAlerts = createSelector(campaignSelector, state => state.promoAlerts);
export const getTopPosts = createSelector(campaignSelector, state => state.topPosts);
export const getSearchPosts = createSelector(campaignSelector, state => state.searchPosts);
export const getRecentPosts = createSelector(campaignSelector, state => state.recentPosts);
export const getDayOptions = createSelector(campaignSelector, state => state.dayOptions);
export const getCampaignListings = createSelector(campaignSelector, state => state.listings);

// EMAIL TEMPLATES
export const getEmailTemplates = createSelector(adminSelector, state => state.emailTemplates);
export const getCurrentEmailTemplate = createSelector(adminSelector, state => state.currentEmailTemplate);

// INVOICES
export const getCurrentInvoice = createSelector(invoiceSelector, state => state.invoice);
export const getAllInvoices = createSelector(invoiceSelector, state => state.invoices);

// NEWS ITEMS
export * as content from './content';
export * as photos from './photos';
export * as photoSets from './photoSets';
export * as series from './series';
export * as campaigns from './campaigns';
export * as reps from './reps';
export * as users from './user';
export * as firms from './firms';
export * as listings from './listings';
export * as showcase from './showcase';
export * as admin from './admin';
export * as templates from './templates';
